/* global axios */
import ApiClient from './ApiClient';

class KefubaoAPI extends ApiClient {
  constructor() {
    super('kefubao', { accountScoped: true });
  }

  translate({ text, targetLanguage }) {
    return axios.post(`${this.url}/translate`, {
      text,
      target_language: targetLanguage,
    });
  }

  quickReplies({ text, language }) {
    return axios.post(`${this.url}/quick_replies`, {
      text,
      language,
    });
  }
}

export default new KefubaoAPI();
